/**
 * optionally wrap children based on a condition
 */
function ConditionallyWrap({ children, condition, Wrapper, ...rest }) {
  if (condition) return (
    <Wrapper {...rest}>
      {children}
    </Wrapper>
  );

  return children;
}

export default ConditionallyWrap
